module.exports = __webpack_public_path__ + "img/REWARD04.5abf47fc.png";